const regions = {
    data() {
        return {
            cn_regions: [
                "香港",
                "澳門"
            ],
            en_regions: [
                "香港",
                "澳門"
            ],
            cn_type: [
                "博彩業",
                "工業",
                "服務業",
                "郵電",
                "通信",
                "社區服務",
                "批發",
                "零售業",
                "慈善機構"
            ],
            en_type: [
                "en",
                "工業",
                "服務業",
                "郵電",
                "通信",
                "社區服務",
                "批發",
                "零售業",
                "慈善機構"
            ]
        }
    }
}

const member = {
    data() {
        return {
            power_options: [ // 权限选项
				{
				    power_id: 16,
				    power_name: this.$t("message.cmember.power16"),
				},
				{
				    power_id: 24,
				    power_name: this.$t("message.cmember.power24"),
				},
				{
				    power_id: 17,
				    power_name: this.$t("message.cmember.power17"),
				},
                {
                    power_id: 1,
                    power_name: this.$t("message.cmember.power1"),
                },
				{
				    power_id: 3,
				    power_name: this.$t("message.cmember.power3"),
				},
                {
                    power_id: 2,
                    power_name: this.$t("message.cmember.power2"),
                },
				{
				    power_id: 5,
				    power_name: this.$t("message.cmember.power5"),
				},
                {
                    power_id: 4,
                    power_name: this.$t("message.cmember.power4"),
                },
               {
                   power_id: 18,
                   power_name: this.$t("message.cmember.power18"),
               },
			   {
			       power_id: 19,
			       power_name: this.$t("message.cmember.power19"),
			   },
			   {
			       power_id: 20,
			       power_name: this.$t("message.cmember.power20"),
			   },
			   {
			       power_id: 11,
			       power_name: this.$t("message.cmember.power11"),
			   },
			   {
			       power_id: 12,
			       power_name: this.$t("message.cmember.power12"),
			   },
			   {
			       power_id: 13,
			       power_name: this.$t("message.cmember.power13"),
			   },
			   {
			       power_id: 14,
			       power_name: this.$t("message.cmember.power14"),
			   },
			   {
			       power_id: 15,
			       power_name: this.$t("message.cmember.power15"),
			   },
                {
                    power_id: 6,
                    power_name: this.$t("message.cmember.power6"),
                },
                {
                    power_id: 7,
                    power_name: this.$t("message.cmember.power7"),
                },
                {
                    power_id: 8,
                    power_name: this.$t("message.cmember.power8"),
                },
                {
                    power_id: 9,
                    power_name: this.$t("message.cmember.power9"),
                },
                {
                    power_id: 10,
                    power_name: this.$t("message.cmember.power10"),
                },
				{
				    power_id: 21,
				    power_name: this.$t("message.cmember.power21"),
				},
				{
				    power_id: 23,
				    power_name: this.$t("message.cmember.power23"),
				},
				
				
				
            ]
        }
    }
}

export {
    regions,
    member
}